import React from 'react';

import { formatClock } from '../utils/date';

function millisecondsUntilNextSecond() {
  return Math.max(25, 1000 - new Date().getMilliseconds());
}

export default function Clock() {
  const [time, setTime] = React.useState(() => formatClock());
  const [hours = '00', minutes = '00', seconds = '00'] = time.split(':');

  React.useEffect(() => {
    let timer;
    const tick = () => {
      setTime(formatClock());
      timer = window.setTimeout(tick, millisecondsUntilNextSecond());
    };

    timer = window.setTimeout(tick, millisecondsUntilNextSecond());
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <span
      className="header-main-title clock"
      data-testid="clock"
      role="timer"
      aria-label={time}
    >
      <span className="clock-primary" aria-hidden="true">{hours}:{minutes}</span>
      <span className="clock-seconds" aria-hidden="true">:{seconds}</span>
    </span>
  );
}
